import React from 'react'
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';

const CustomDateRangePicker = ({ from, to, onApply, ...props }) => {
  return (<>
    <DateRangePicker
      initialSettings={{
        startDate: moment().subtract(30, 'day').format('MM/DD/YYYY'),
        endDate: moment().add(1, 'day').format('MM/DD/YYYY'),
        ranges: {
          Today: [moment().toDate(), moment().toDate()],
          Yesterday: [
            moment().subtract(1, 'days').toDate(),
            moment().subtract(1, 'days').toDate(),
          ],
          'Last 7 Days': [
            moment().subtract(6, 'days').toDate(),
            moment().toDate(),
          ],
          'Last 30 Days': [
            moment().subtract(29, 'days').toDate(),
            moment().toDate(),
          ],
          'This Month': [
            moment().startOf('month').toDate(),
            moment().endOf('month').toDate(),
          ],
          'Last Month': [
            moment().subtract(1, 'month').startOf('month').toDate(),
            moment().subtract(1, 'month').endOf('month').toDate(),
          ],
        }
      }}
      onApply={onApply}
      {...props}
    >
      <div className='d-flex flex-row gap-2 justify-content-end' style={{ maxWidth: 'auto' }}>
        <div className='d-flex flex-row bg-primary text-white p-2 rounded-2 gap-2' style={{ maxWidth: 'auto', cursor: 'pointer' }}>
          <div>
            {moment(from).format('D MMM YY')}
          </div>
          <span>-</span>
          <div>
            {moment(to).format('D MMM YY')}
          </div>
        </div>
      </div>
    </DateRangePicker>
  </>);
}

export default CustomDateRangePicker;
